@if (enableNone()) {
  <div class="noFolders" (click)="itemSelected.emit(null)">{{ 'shared.none' | translate }}</div>
}
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent()" matTreeNodePadding>
    <button mat-icon-button disabled>
      <mat-icon class="mat-icon-rtl-mirror">chevron_right</mat-icon>
    </button>

    <mat-form-field appearance="outline" #inputFolderNameRef>
      <input
        matInput
        autocomplete="no-autofill"
        [placeholder]="'shared.newFolder' | translate"
        [formControl]="folderFormControl"
        [errorStateMatcher]="noNameMatcher"
        (click)="$event.stopPropagation()"
        (keydown.enter)="saveNode(node)"
        (blur)="clearIfEmpty()"
        />
      </mat-form-field>
      <div class="saveicon">
        <mat-icon (click)="saveNode(node)">save</mat-icon>
      </div>
    </mat-tree-node>

    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="itemSelected.emit(node)">
      <button mat-icon-button matTreeNodeToggle (click)="$event.stopPropagation(); toggleNode(node)">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <span class="leaf" [ngClass]="{ selected: node.selected }" (click)="updateSelection(node)">
        {{ node | dataCellFormatter : nodeDataParser() }}
      </span>
      @if (node.expanded && !selectionModeOnly()) {
        <button
          mat-icon-button
          class="addfolder-btn"
          (click)="$event.stopPropagation(); addNewItem(node)"
          >
          <mat-icon svgIcon="add-icon" class="addfolder-icon"></mat-icon>
        </button>
      }
    </mat-tree-node>
  </mat-tree>
